{
  "version": 1,
  "at": "2026-09-14",
  "country": "ES",
  "currency": "EUR",
  "note": "Estimaciones iniciales de referencia, sin IVA. No son cotizaciones observadas ni precios garantizados. Confirmar con factura o proveedor.",
  "entries": [
    {
      "name": "harina de trigo",
      "unit": "kg",
      "unitPrice": 1.1
    },
    {
      "name": "harina integral",
      "unit": "kg",
      "unitPrice": 1.5
    },
    {
      "name": "harina de fuerza",
      "unit": "kg",
      "unitPrice": 1.4
    },
    {
      "name": "harina de maíz",
      "unit": "kg",
      "unitPrice": 1.8
    },
    {
      "name": "arroz",
      "unit": "kg",
      "unitPrice": 1.5
    },
    {
      "name": "arroz bomba",
      "unit": "kg",
      "unitPrice": 3.5
    },
    {
      "name": "arroz basmati",
      "unit": "kg",
      "unitPrice": 2.2
    },
    {
      "name": "pasta",
      "unit": "kg",
      "unitPrice": 1.6
    },
    {
      "name": "espaguetis",
      "unit": "kg",
      "unitPrice": 1.5
    },
    {
      "name": "macarrones",
      "unit": "kg",
      "unitPrice": 1.5
    },
    {
      "name": "cuscús",
      "unit": "kg",
      "unitPrice": 2.2
    },
    {
      "name": "quinoa",
      "unit": "kg",
      "unitPrice": 5.0
    },
    {
      "name": "avena",
      "unit": "kg",
      "unitPrice": 1.8
    },
    {
      "name": "pan rallado",
      "unit": "kg",
      "unitPrice": 1.8
    },
    {
      "name": "pan",
      "unit": "kg",
      "unitPrice": 2.4
    },
    {
      "name": "pan de molde",
      "unit": "kg",
      "unitPrice": 2.5
    },
    {
      "name": "azúcar",
      "unit": "kg",
      "unitPrice": 1.2
    },
    {
      "name": "azúcar moreno",
      "unit": "kg",
      "unitPrice": 1.8
    },
    {
      "name": "sal",
      "unit": "kg",
      "unitPrice": 0.4
    },
    {
      "name": "sal en escamas",
      "unit": "kg",
      "unitPrice": 8.0
    },
    {
      "name": "pollo entero",
      "unit": "kg",
      "unitPrice": 3.5
    },
    {
      "name": "pechuga de pollo",
      "unit": "kg",
      "unitPrice": 6.0
    },
    {
      "name": "muslo de pollo",
      "unit": "kg",
      "unitPrice": 3.8
    },
    {
      "name": "alitas de pollo",
      "unit": "kg",
      "unitPrice": 3.5
    },
    {
      "name": "pavo",
      "unit": "kg",
      "unitPrice": 6.0
    },
    {
      "name": "pechuga de pavo",
      "unit": "kg",
      "unitPrice": 7.0
    },
    {
      "name": "conejo",
      "unit": "kg",
      "unitPrice": 7.0
    },
    {
      "name": "pato",
      "unit": "kg",
      "unitPrice": 8.0
    },
    {
      "name": "lomo de cerdo",
      "unit": "kg",
      "unitPrice": 5.5
    },
    {
      "name": "solomillo de cerdo",
      "unit": "kg",
      "unitPrice": 8.0
    },
    {
      "name": "costilla de cerdo",
      "unit": "kg",
      "unitPrice": 5.5
    },
    {
      "name": "panceta",
      "unit": "kg",
      "unitPrice": 5.0
    },
    {
      "name": "secreto ibérico",
      "unit": "kg",
      "unitPrice": 13.0
    },
    {
      "name": "presa ibérica",
      "unit": "kg",
      "unitPrice": 18.0
    },
    {
      "name": "carrillera de cerdo",
      "unit": "kg",
      "unitPrice": 8.0
    },
    {
      "name": "jamón cocido",
      "unit": "kg",
      "unitPrice": 7.0
    },
    {
      "name": "jamón serrano",
      "unit": "kg",
      "unitPrice": 12.0
    },
    {
      "name": "jamón ibérico",
      "unit": "kg",
      "unitPrice": 35.0
    },
    {
      "name": "bacon",
      "unit": "kg",
      "unitPrice": 7.0
    },
    {
      "name": "chorizo",
      "unit": "kg",
      "unitPrice": 7.0
    },
    {
      "name": "salchichón",
      "unit": "kg",
      "unitPrice": 8.0
    },
    {
      "name": "morcilla",
      "unit": "kg",
      "unitPrice": 5.0
    },
    {
      "name": "salchicha",
      "unit": "kg",
      "unitPrice": 5.0
    },
    {
      "name": "ternera picada",
      "unit": "kg",
      "unitPrice": 9.0
    },
    {
      "name": "cerdo picado",
      "unit": "kg",
      "unitPrice": 5.0
    },
    {
      "name": "solomillo de ternera",
      "unit": "kg",
      "unitPrice": 25.0
    },
    {
      "name": "entrecot de ternera",
      "unit": "kg",
      "unitPrice": 17.0
    },
    {
      "name": "falda de ternera",
      "unit": "kg",
      "unitPrice": 9.0
    },
    {
      "name": "morcillo de ternera",
      "unit": "kg",
      "unitPrice": 10.0
    },
    {
      "name": "rabo de toro",
      "unit": "kg",
      "unitPrice": 12.0
    },
    {
      "name": "cordero",
      "unit": "kg",
      "unitPrice": 12.0
    },
    {
      "name": "merluza",
      "unit": "kg",
      "unitPrice": 9.0
    },
    {
      "name": "salmón",
      "unit": "kg",
      "unitPrice": 11.0
    },
    {
      "name": "bacalao",
      "unit": "kg",
      "unitPrice": 13.0
    },
    {
      "name": "atún",
      "unit": "kg",
      "unitPrice": 15.0
    },
    {
      "name": "bonito",
      "unit": "kg",
      "unitPrice": 10.0
    },
    {
      "name": "sardina",
      "unit": "kg",
      "unitPrice": 4.0
    },
    {
      "name": "boquerón",
      "unit": "kg",
      "unitPrice": 5.0
    },
    {
      "name": "dorada",
      "unit": "kg",
      "unitPrice": 8.0
    },
    {
      "name": "lubina",
      "unit": "kg",
      "unitPrice": 10.0
    },
    {
      "name": "rape",
      "unit": "kg",
      "unitPrice": 16.0
    },
    {
      "name": "lenguado",
      "unit": "kg",
      "unitPrice": 18.0
    },
    {
      "name": "rodaballo",
      "unit": "kg",
      "unitPrice": 15.0
    },
    {
      "name": "trucha",
      "unit": "kg",
      "unitPrice": 6.0
    },
    {
      "name": "calamar",
      "unit": "kg",
      "unitPrice": 10.0
    },
    {
      "name": "sepia",
      "unit": "kg",
      "unitPrice": 9.0
    },
    {
      "name": "pulpo",
      "unit": "kg",
      "unitPrice": 18.0
    },
    {
      "name": "mejillón",
      "unit": "kg",
      "unitPrice": 3.0
    },
    {
      "name": "almeja",
      "unit": "kg",
      "unitPrice": 12.0
    },
    {
      "name": "berberecho",
      "unit": "kg",
      "unitPrice": 10.0
    },
    {
      "name": "gambas",
      "unit": "kg",
      "unitPrice": 12.0
    },
    {
      "name": "langostino",
      "unit": "kg",
      "unitPrice": 10.0
    },
    {
      "name": "gambón",
      "unit": "kg",
      "unitPrice": 9.0
    },
    {
      "name": "cigala",
      "unit": "kg",
      "unitPrice": 25.0
    },
    {
      "name": "vieira",
      "unit": "kg",
      "unitPrice": 22.0
    },
    {
      "name": "mantequilla",
      "unit": "kg",
      "unitPrice": 7.0
    },
    {
      "name": "mozzarella",
      "unit": "kg",
      "unitPrice": 6.0
    },
    {
      "name": "parmesano",
      "unit": "kg",
      "unitPrice": 16.0
    },
    {
      "name": "queso manchego",
      "unit": "kg",
      "unitPrice": 12.0
    },
    {
      "name": "queso cheddar",
      "unit": "kg",
      "unitPrice": 7.0
    },
    {
      "name": "queso de cabra",
      "unit": "kg",
      "unitPrice": 11.0
    },
    {
      "name": "queso azul",
      "unit": "kg",
      "unitPrice": 10.0
    },
    {
      "name": "queso crema",
      "unit": "kg",
      "unitPrice": 5.0
    },
    {
      "name": "queso fresco",
      "unit": "kg",
      "unitPrice": 5.0
    },
    {
      "name": "ricotta",
      "unit": "kg",
      "unitPrice": 6.0
    },
    {
      "name": "mascarpone",
      "unit": "kg",
      "unitPrice": 7.0
    },
    {
      "name": "yogur natural",
      "unit": "kg",
      "unitPrice": 2.0
    },
    {
      "name": "tomate",
      "unit": "kg",
      "unitPrice": 2.0
    },
    {
      "name": "tomate cherry",
      "unit": "kg",
      "unitPrice": 3.0
    },
    {
      "name": "cebolla",
      "unit": "kg",
      "unitPrice": 1.0
    },
    {
      "name": "cebolla morada",
      "unit": "kg",
      "unitPrice": 1.5
    },
    {
      "name": "ajo",
      "unit": "kg",
      "unitPrice": 4.0
    },
    {
      "name": "patata",
      "unit": "kg",
      "unitPrice": 1.0
    },
    {
      "name": "boniato",
      "unit": "kg",
      "unitPrice": 1.8
    },
    {
      "name": "zanahoria",
      "unit": "kg",
      "unitPrice": 1.0
    },
    {
      "name": "puerro",
      "unit": "kg",
      "unitPrice": 2.0
    },
    {
      "name": "apio",
      "unit": "kg",
      "unitPrice": 1.8
    },
    {
      "name": "calabacín",
      "unit": "kg",
      "unitPrice": 1.5
    },
    {
      "name": "berenjena",
      "unit": "kg",
      "unitPrice": 1.8
    },
    {
      "name": "pimiento rojo",
      "unit": "kg",
      "unitPrice": 2.5
    },
    {
      "name": "pimiento verde",
      "unit": "kg",
      "unitPrice": 2.0
    },
    {
      "name": "pepino",
      "unit": "kg",
      "unitPrice": 1.5
    },
    {
      "name": "calabaza",
      "unit": "kg",
      "unitPrice": 1.3
    },
    {
      "name": "brócoli",
      "unit": "kg",
      "unitPrice": 2.0
    },
    {
      "name": "coliflor",
      "unit": "kg",
      "unitPrice": 2.0
    },
    {
      "name": "repollo",
      "unit": "kg",
      "unitPrice": 1.0
    },
    {
      "name": "espinacas",
      "unit": "kg",
      "unitPrice": 3.0
    },
    {
      "name": "acelgas",
      "unit": "kg",
      "unitPrice": 2.0
    },
    {
      "name": "lechuga",
      "unit": "kg",
      "unitPrice": 2.0
    },
    {
      "name": "rúcula",
      "unit": "kg",
      "unitPrice": 6.0
    },
    {
      "name": "canónigos",
      "unit": "kg",
      "unitPrice": 7.0
    },
    {
      "name": "espárrago verde",
      "unit": "kg",
      "unitPrice": 6.0
    },
    {
      "name": "alcachofa",
      "unit": "kg",
      "unitPrice": 3.0
    },
    {
      "name": "judía verde",
      "unit": "kg",
      "unitPrice": 3.0
    },
    {
      "name": "guisantes",
      "unit": "kg",
      "unitPrice": 2.0
    },
    {
      "name": "habas",
      "unit": "kg",
      "unitPrice": 2.5
    },
    {
      "name": "champiñón",
      "unit": "kg",
      "unitPrice": 3.0
    },
    {
      "name": "setas",
      "unit": "kg",
      "unitPrice": 6.0
    },
    {
      "name": "boletus",
      "unit": "kg",
      "unitPrice": 18.0
    },
    {
      "name": "lentejas",
      "unit": "kg",
      "unitPrice": 2.0
    },
    {
      "name": "garbanzos",
      "unit": "kg",
      "unitPrice": 2.0
    },
    {
      "name": "alubias",
      "unit": "kg",
      "unitPrice": 3.0
    },
    {
      "name": "maíz dulce",
      "unit": "kg",
      "unitPrice": 2.5
    },
    {
      "name": "aceitunas",
      "unit": "kg",
      "unitPrice": 4.0
    },
    {
      "name": "pepinillos",
      "unit": "kg",
      "unitPrice": 3.0
    },
    {
      "name": "alcaparras",
      "unit": "kg",
      "unitPrice": 7.0
    },
    {
      "name": "tomate triturado",
      "unit": "kg",
      "unitPrice": 1.2
    },
    {
      "name": "tomate frito",
      "unit": "kg",
      "unitPrice": 1.6
    },
    {
      "name": "aguacate",
      "unit": "kg",
      "unitPrice": 5.0
    },
    {
      "name": "limón",
      "unit": "kg",
      "unitPrice": 1.8
    },
    {
      "name": "lima",
      "unit": "kg",
      "unitPrice": 3.0
    },
    {
      "name": "naranja",
      "unit": "kg",
      "unitPrice": 1.4
    },
    {
      "name": "manzana",
      "unit": "kg",
      "unitPrice": 1.8
    },
    {
      "name": "pera",
      "unit": "kg",
      "unitPrice": 2.0
    },
    {
      "name": "plátano",
      "unit": "kg",
      "unitPrice": 1.8
    },
    {
      "name": "fresa",
      "unit": "kg",
      "unitPrice": 4.0
    },
    {
      "name": "frambuesa",
      "unit": "kg",
      "unitPrice": 10.0
    },
    {
      "name": "arándanos",
      "unit": "kg",
      "unitPrice": 9.0
    },
    {
      "name": "piña",
      "unit": "kg",
      "unitPrice": 1.8
    },
    {
      "name": "mango",
      "unit": "kg",
      "unitPrice": 3.0
    },
    {
      "name": "melocotón",
      "unit": "kg",
      "unitPrice": 2.5
    },
    {
      "name": "melón",
      "unit": "kg",
      "unitPrice": 1.5
    },
    {
      "name": "sandía",
      "unit": "kg",
      "unitPrice": 1.0
    },
    {
      "name": "uva",
      "unit": "kg",
      "unitPrice": 3.0
    },
    {
      "name": "almendra",
      "unit": "kg",
      "unitPrice": 8.0
    },
    {
      "name": "nuez",
      "unit": "kg",
      "unitPrice": 8.0
    },
    {
      "name": "avellana",
      "unit": "kg",
      "unitPrice": 10.0
    },
    {
      "name": "pistacho",
      "unit": "kg",
      "unitPrice": 18.0
    },
    {
      "name": "piñón",
      "unit": "kg",
      "unitPrice": 35.0
    },
    {
      "name": "cacahuete",
      "unit": "kg",
      "unitPrice": 4.0
    },
    {
      "name": "pasas",
      "unit": "kg",
      "unitPrice": 4.0
    },
    {
      "name": "dátiles",
      "unit": "kg",
      "unitPrice": 5.0
    },
    {
      "name": "chocolate negro",
      "unit": "kg",
      "unitPrice": 8.0
    },
    {
      "name": "chocolate blanco",
      "unit": "kg",
      "unitPrice": 8.0
    },
    {
      "name": "cacao en polvo",
      "unit": "kg",
      "unitPrice": 9.0
    },
    {
      "name": "café",
      "unit": "kg",
      "unitPrice": 12.0
    },
    {
      "name": "pimentón dulce",
      "unit": "kg",
      "unitPrice": 8.0
    },
    {
      "name": "pimienta negra",
      "unit": "kg",
      "unitPrice": 12.0
    },
    {
      "name": "comino",
      "unit": "kg",
      "unitPrice": 10.0
    },
    {
      "name": "orégano",
      "unit": "kg",
      "unitPrice": 10.0
    },
    {
      "name": "canela",
      "unit": "kg",
      "unitPrice": 12.0
    },
    {
      "name": "curry",
      "unit": "kg",
      "unitPrice": 10.0
    },
    {
      "name": "perejil",
      "unit": "kg",
      "unitPrice": 5.0
    },
    {
      "name": "cilantro",
      "unit": "kg",
      "unitPrice": 6.0
    },
    {
      "name": "albahaca",
      "unit": "kg",
      "unitPrice": 12.0
    },
    {
      "name": "menta",
      "unit": "kg",
      "unitPrice": 10.0
    },
    {
      "name": "romero",
      "unit": "kg",
      "unitPrice": 8.0
    },
    {
      "name": "tomillo",
      "unit": "kg",
      "unitPrice": 10.0
    },
    {
      "name": "laurel",
      "unit": "kg",
      "unitPrice": 12.0
    },
    {
      "name": "mostaza",
      "unit": "kg",
      "unitPrice": 3.0
    },
    {
      "name": "mayonesa",
      "unit": "kg",
      "unitPrice": 3.0
    },
    {
      "name": "kétchup",
      "unit": "kg",
      "unitPrice": 2.0
    },
    {
      "name": "miel",
      "unit": "kg",
      "unitPrice": 5.0
    },
    {
      "name": "aceite de oliva",
      "unit": "l",
      "unitPrice": 5.0
    },
    {
      "name": "aceite de oliva virgen extra",
      "unit": "l",
      "unitPrice": 6.0
    },
    {
      "name": "aceite de girasol",
      "unit": "l",
      "unitPrice": 1.6
    },
    {
      "name": "leche",
      "unit": "l",
      "unitPrice": 0.9
    },
    {
      "name": "nata",
      "unit": "l",
      "unitPrice": 3.5
    },
    {
      "name": "vinagre de vino",
      "unit": "l",
      "unitPrice": 1.0
    },
    {
      "name": "vinagre de manzana",
      "unit": "l",
      "unitPrice": 1.5
    },
    {
      "name": "vinagre balsámico",
      "unit": "l",
      "unitPrice": 3.0
    },
    {
      "name": "vino blanco",
      "unit": "l",
      "unitPrice": 2.0
    },
    {
      "name": "vino tinto",
      "unit": "l",
      "unitPrice": 2.0
    },
    {
      "name": "cerveza",
      "unit": "l",
      "unitPrice": 1.5
    },
    {
      "name": "salsa de soja",
      "unit": "l",
      "unitPrice": 3.0
    },
    {
      "name": "leche de coco",
      "unit": "l",
      "unitPrice": 3.0
    },
    {
      "name": "caldo de pollo",
      "unit": "l",
      "unitPrice": 1.5
    },
    {
      "name": "caldo de verduras",
      "unit": "l",
      "unitPrice": 1.5
    },
    {
      "name": "huevo",
      "unit": "pz",
      "unitPrice": 0.22
    },
    {
      "name": "tortilla de trigo",
      "unit": "pz",
      "unitPrice": 0.2
    },
    {
      "name": "pan de hamburguesa",
      "unit": "pz",
      "unitPrice": 0.35
    },
    {
      "name": "arroz carnaroli",
      "unit": "kg",
      "unitPrice": 3
    }
  ]
}
